import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/checklists")({
  beforeLoad: requirePermissionGuard("hca.products.read"),
});
